/**
 * TEMPLATE-OPTIONS.MODEL.TS
 * Options for the template
 */

export class TemplateOptions {
  editResponseLabelByQuestion: boolean = false; //Custom label for scale
  emojiMode: boolean = false;
  jumpRules: { id: string; type: "proposition"; jumpToTopic: string }[] = []
  exitTrigger: boolean = false; //Define a trigger for exit the questionnaire
  exitTriggerQuestionId: string | null = null; //Id of the question
  exitTriggerResponse: number | null = null; //Response
  hideAxisPage: boolean = false;
  hideQuestionSecondaryText: boolean = false; //Hide text for secondary question
  hideTopicName: boolean = false;
  nsppOnTop: boolean = false; //Put "not concerned" before the scale
  responseEmojiLabel_no_fr: string = "";
  responseEmojiLabel_yes_fr: string = "";
  showCircle: boolean = false;
  triggerNegativeAnswer: number = 50; //Trigger to display question negative
  triggerPositiveAnswer: number = 50; //Trigger to display question positive
  triggerNegativeAnswerNps: number = 70; //Trigger to display question negative (NPS)
  triggerPositiveAnswerNps: number = 70; //Trigger to display question positive (NPS)
  withoutAxisColor: string = "#c1c1c1"; //default color for topic without axis customisable
  constructor(item: Partial<TemplateOptions> = {}) {
    Object.assign(this, item);
  }
}
